import { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { format } from 'date-fns';
import { Audit, useAudit_GetAuditTrailLazyQuery } from 'queries';

import Modal from 'common/modal';
import ModalContent from 'common/modal-content';
import { NotificationSeverity, showAlert } from 'utils/notification-manager';

interface Props {
  entityId: string;
  setShowModal: (value: boolean) => void;
  showModal: boolean;
}

const useStyles = makeStyles(() => ({
  record: {
    display: 'flex',
  },
  recordTitle: {
    display: 'flex',
    fontWeight: 'bold',
  },
  date: {
    flex: 3,
  },
  action: {
    flex: 3,
  },
  description: {
    flex: 3,
  },
}));

export default function AuditModal({ entityId, setShowModal, showModal }: Props) {
  const classes = useStyles();
  const [auditRecords, setAuditRecords] = useState<Array<Partial<Audit>>>([]);
  const onExitClick = () => {
    setShowModal(false);
  };

  const [getAuditTrail] = useAudit_GetAuditTrailLazyQuery({
    onCompleted(data) {
      setAuditRecords(data.data);
    },
    onError: (e) => {
      showAlert({
        message: 'Error getting audit trail: ' + e.message,
        severity: NotificationSeverity.ERROR,
      });
    },
  });

  useEffect(() => {
    if (entityId) {
      getAuditTrail({
        variables: {
          entityId: entityId,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entityId]);

  return (
    <Modal
      setShowModal={setShowModal}
      onExitClick={onExitClick}
      showModal={showModal}
      showActions={false}
      content={
        <ModalContent>
          <Typography variant="h5">Audit</Typography>
          <div className={classes.recordTitle}>
            <div className={classes.date}>Date</div>
            <div className={classes.action}>Action</div>
            <div className={classes.description}>Description</div>
          </div>
          <>
            {auditRecords.map((record) => {
              return (
                <div className={classes.record}>
                  <div className={classes.date}>
                    {format(Date.parse(record.createdAt.toString()), 'h:mmaaa LLL d, y')}
                  </div>
                  <div className={classes.action}>{record.action}</div>
                  <div className={classes.description}>{record.description}</div>
                </div>
              );
            })}
            {auditRecords.length === 0 && (
              <div className={classes.record}>
                <div className={classes.date}></div>
                <div className={classes.action}>No records</div>
                <div className={classes.description}></div>
              </div>
            )}
          </>
        </ModalContent>
      }
      loading={false}
      actionDisabled={false}
      maxWidth="sm"
    />
  );
}
